import classnames from 'classnames'
import React, { useEffect, useState, useRef } from 'react'

import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import { Link } from 'react-router-dom'
import { Col, Row, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, InputGroup, InputGroupAddon } from 'reactstrap'

import SweetAlert from 'react-bootstrap-sweetalert'

import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation'
import {
  newProformaAction,
  newPayFlow,
  setProformaTheme,
  setProformaThemeStatusChange,
  setProformaThemeReqSuccess,
  getPaymentFlowsThemeAction,
} from '../../store/planlama-ve-takvim/actions'
import { at, forEach, last, set, update } from 'lodash'
import { act } from 'react'
import { setGlobalCssModule } from 'reactstrap/es/utils'
function getFileName(fullPath) {
  if (fullPath) {
    var startIndex = fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/')
    var filename = fullPath.substring(startIndex)
    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
      filename = filename.substring(1)
    }
    return filename
  }
}

function startWith(string, search) {
  return string.substr(0, search.length) === search;
}

const APP = props => {
  const [pageData, setPageData] = useState(props);

  const dispatch = useDispatch()
  const [titleSubList, setTitleSubList] = useState(pageData.currentSubTitle)
  const [deleteModal, setDeleteModal] = useState(false)
  const [showLoader, setshowLoader] = useState(false)
  const [activeProformaData, setactiveProformaData] = useState({})
  const [appendButtonDisabledStatus, setappendButtonDisabledStatus] = useState(true)
  const [proforma_durum, set_proforma_durum] = useState(false)
  const [show_save_button, setShowSaveButton] = useState(true)
  const [udataGlobal, setudataGlobal] = useState(0)
  const [appendSubmitData, setappendSubmitData] = useState(false)
  const [props_payment_theme_flows, setPropsProformas] = useState(props.payment_theme_flows)
  const [lastFakeEvent, setLastFakeEvent] = useState({ target: { value: '', name: 'proforma_id' } })

  const { proformas, flow_status, saved_proforma_status, saved_proforma } = useSelector(state => ({
    proformas: state.PlanlamaVeTakvim.proformas ? state.PlanlamaVeTakvim.proformas : { status: false, msg: null },
    flow_status: state.PlanlamaVeTakvim.flow_status ? state.PlanlamaVeTakvim.flow_status : { status: false, msg: null },
    saved_proforma_status: state.PlanlamaVeTakvim.saved_proforma_status ? state.PlanlamaVeTakvim.saved_proforma_status : false,
    saved_proforma: state.PlanlamaVeTakvim.saved_data ? state.PlanlamaVeTakvim.saved_data : null,
  }))

  const [active_theme_objects, active_theme_objects_set] = useState([]);
  const [saved_proforma_status_forsw, setProformaSaveStatus] = useState(props.sw);
  const additionalRowDefaultData = { id: Date.now(), title: '', deger: '' };
  const [additionalRows, setAdditionalRows] = useState([additionalRowDefaultData]);
  const addAdditionalRow = () => {
    setAdditionalRows([...additionalRows, { id: Date.now(), title: '', deger: '' }]);
  };

  const swclose = () => {
    setProformaSaveStatus(false);
  }
  const swopen = () => {
    setProformaSaveStatus(true);
  }
  const removeAdditionalRow = (id) => {
    if (additionalRows.length > 1) {
      setAdditionalRows(additionalRows.filter((row) => row.id !== id));
    } else {
      alert('En az bir satır bulunmalıdır!');
    }
  };
  const isFirstRun = useRef(true);
  const isFirstRunPayFLow = useRef(true);
  const [proforma_select_status, proforma_select_status_change] = useState(false);
  const [active_theme_type, active_theme_type_set] = useState(false);
  const [active_theme_label, active_theme_label_set] = useState(false);
  const [active_proforma, setActiveProformaId] = useState(false);

  const [current_proc_proforma, setcpp] = useState({ status: false, msg: null })
  const [current_flow_status, setcfs] = useState({ saved_data: {}, msg: null })
  const [available_types, set_available_types] = useState({ "File": "File", "Text": "Text", "Select": "Select", "Radio": "Radio", "Checkbox": "Checkbox" })
  useEffect(() => {
    if (localStorage.getItem('authUser')) {
      const obj = JSON.parse(localStorage.getItem('authUser'))
      setUserType(obj.user_type)
      setUserData(obj)
    }
  }, [pageData.success])

  const clickedButtonRefCurrent = useRef({});
  const [user_type, setUserType] = useState('DCT')
  const [AuthUserData, setUserData] = useState({})
  const [new_proforma_modal_show, setNewProformaModal] = useState(false)
  const [new_theme_modal_show, setNewThemeModal] = useState(false)
  const [additionalInputsModalOpen, additionalInputsModalOpenFunc] = useState(false)
  const [new_payment_flow, set_new_payment_flow] = useState(false)
  const [uyari, setUyari] = useState(false)
  const [uti, setUti] = useState(0)
  const [setAlertWhenchanged, setAlertWhenchangedF] = useState(false)
  const [updateModal, setupdateModalF] = useState(false)

  const [proforma_modal_data, proformaSetpaymentModalData] = useState({ title: null, project_id: pageData.project_id, status: false, value: null, id: null, objects: [] })

  const [paymentModalData, setPaymentModalData] = useState({ id: null, name: null, path: null, value: null, user_id: false, proforma_id: null, process_time: null, id: null, delete_wf: false })
  const proforma_data_change_title = (event) => {

    proformaSetpaymentModalData(proforma_modal_data => ({
      ...proforma_modal_data,
      title: event.target.value
    }), () => {
    }
    );
  };
  const proforma_data_change_budget = (event) => {
    proformaSetpaymentModalData(proforma_modal_data => ({
      ...proforma_modal_data,
      value: event.target.value
    }), () => {
      // This callback is executed after the state has been updated
    }
    );
  };
  const paymentFlowReButton = () => {
    setTitleSubList("Ödeme Akışı Şablonları")
    payflowactions(pageData.payment_id)
  }
  const proforma_list = () => {
    setTitleSubList("Proforma Listesi")
  }
  const new_proforma_modal_action = () => {
    proforma_modal_data.project_id = pageData.project_id;
    setNewProformaModal(!new_proforma_modal_show)
    if (new_proforma_modal_show) {
      proforma_select_status_change(false);
    }
  }
  const toggleAdditionalInputsModal = (status = null, oitem = null) => {
    console.log("toggleAdditionalInputsModal")
    console.log(status)
    console.log(oitem)
    if (status == true || status == false) {
      additionalInputsModalOpenFunc(status)
    }
    else {
      additionalInputsModalOpenFunc(!additionalInputsModalOpen)
    }
    if (oitem) {
      if (oitem.addAdditionalRow.length === 0) {
        oitem.addAdditionalRow.push(additionalRows);
      }
      setAdditionalRows(oitem.addAdditionalRow);
    }
  }
  const new_theme_modal_action = () => {
    proforma_modal_data.project_id = pageData.project_id;
    setNewThemeModal(!new_theme_modal_show)
    if (new_theme_modal_show) {
      proforma_select_status_change(false);
    }
  }
  const edit_proforma_modal_action = (t, proforma_id) => {
    const editProformaData = pageData.payment_flows.proformas.find(item => item.id === proforma_id);
    if (editProformaData.title.includes('(' + editProformaData.value + ')'))
      editProformaData.title = editProformaData.title.substring(0, editProformaData.title.indexOf('(' + editProformaData.value + ')')).trim();

    proformaSetpaymentModalData(proforma_modal_data => ({
      ...proforma_modal_data,
      title: editProformaData.title,
      value: editProformaData.value,
      id: editProformaData.id,
      status: editProformaData.status ? editProformaData.status : false
    }), () => {
    }
    );
    // setNewProformaModal(!new_proforma_modal_show)
  }
  const proformaDurumChange = (event) => {
    const { name, value } = event.target; // Destructure to get name and value from event
    var new_value = ""
    if (value == "true") {
      new_value = "false";
    }
    else {
      new_value = "true";
    }
    activeProformaData.status = new_value == "true" ? true : false;
    dispatch(setProformaThemeStatusChange(active_proforma, new_value))
    dispatch(getPaymentFlowsThemeAction(pageData.payment_id, pageData.project_id));
  };

  const handleModalProformaThemeChange = (event, itemId, udata = 0) => {
    const { name, value } = event.target; // Destructure to get name and value from event
    // setUti(0);
    setudataGlobal(udata);

    // if (name.startsWith() === "input_label" || name.startsWith() === "input_type") {
    //   setLastFakeEvent({ target: { itemId: itemId, name: "proforma_id", update: true, name: name, value: value } })
    // } else {
    //   setLastFakeEvent({ target: { itemId: itemId, name: "proforma_id", update: false, name: name, value: value } })
    // }
    // console.log(lastFakeEvent);

    // active_theme_objects_set([])
    if (value == "") {
      proformaObjectDataSet(value);
      setappendButtonDisabledStatus(true)
      proforma_select_status_change(false);
      return false;
    }
    if (itemId) {
      var ato_id = 0;
      setUti(itemId);
      var new_active_theme_objects = active_theme_objects.map((oitem, index) => {
        if (oitem.id === itemId) {
          ato_id = index;
          const updatedItem = {
            ...oitem,
            input_detail: name === `input_type[${itemId}]` ? value : oitem.input_detail,
            input_label: name === `input_label[${itemId}]` ? value : oitem.input_label,
          };
          // setAdditionalRows(updatedItem.addAdditionalRow);
          console.log("223")
          return updatedItem;
        }
        console.log("226")
        return oitem;
      });
      active_theme_objects_set(new_active_theme_objects);
      console.log("230")
      console.log(new_active_theme_objects)
    }
    if (name === "proforma_id") {
      proformaObjectDataSet(value)
    } else if (name === "input_label") {
      setappendButtonDisabledStatus(false);
      forEach(active_theme_objects, (item, index) => {
        if (item.input_label == value) {
          setappendButtonDisabledStatus(true)
          return false;
        }
        else {
          setappendButtonDisabledStatus(false)
        }
      });
      // When the label input field changes
      active_theme_label_set(value);
    } else if (name === "input_type") {
      // When the type input field changes
      if (value === "File" || value === "Text") {
        toggleAdditionalInputsModal(false);
      } else {
        setAdditionalRows([additionalRowDefaultData]);
        toggleAdditionalInputsModal(true);
      }
      active_theme_type_set(value); // Set the active theme type
    }
  };
  const proformaObjectDataSet = (value) => {
    proforma_select_status_change(true);
    const selectedProforma = props.payment_theme_flows.proformas_theme.find(
      (item) => item.id === value
    );
    if (selectedProforma) {
      set_proforma_durum(selectedProforma.status);
      console.log("266")
      active_theme_objects_set(selectedProforma.objects);
      setactiveProformaData(selectedProforma);
      setActiveProformaId(value);
    } else {
      set_proforma_durum(false);
      setactiveProformaData({ "status": false });
      console.log("273")
      active_theme_objects_set({});
    }
  }


  const appendThemeForProforma = (event) => {

    if (active_theme_type && active_theme_label && active_proforma) {
      var sendAdditionalRows = [];
      if (active_theme_type == "Select" || active_theme_type == "Radio" || active_theme_type == "Checkbox") {
        if (additionalRows.length > 0) {
          additionalRows.map((row, index) => {
            if (row.title && row.deger)
              sendAdditionalRows.push({ title: row.title, deger: row.deger, id: row.id });
          }
          )
        }
        else {
          alert("Lütfen ek bilgileri giriniz");
          return false;
        }
        if (sendAdditionalRows.length == 0) {
          alert("Lütfen ek bilgileri giriniz");
          return false;
        }
      }
      if (active_theme_type == "") {
        alert("Lütfen tip seçiniz");
        return false;
      }
      if (active_theme_label == "") {
        alert("Lütfen etiket seçiniz");
        return false;
      }
      let appendData = dispatch(setProformaTheme(active_theme_type, active_theme_label, active_proforma, "append", null, sendAdditionalRows))

      if (appendData) {
        dispatch(getPaymentFlowsThemeAction(pageData.payment_id, pageData.project_id));
        // setActiveProformaId(value);
      }
      active_theme_type_set(false);


      setappendSubmitData(true);
      active_theme_label_set("");

    }

    // dispatch(setProformaTheme(payment_id, proje_id))
  }
  const removeThemeForProforma = (event) => {
    if (active_theme_type && active_theme_label && active_proforma) {
      dispatch(setProformaTheme(active_theme_type, active_theme_label, active_proforma, "append"))
    }

    // dispatch(setProformaTheme(payment_id, proje_id))
  }

  const updateThemeForProforma = (event, id, proforma_id, eventname = "update") => {
    setUti(id);

    const input_type_element = document.querySelector(`#input_type\\[${id}\\]`); // Escaping square brackets
    const input_label_element = document.querySelector(`#input_label\\[${id}\\]`); // Escaping square brackets
    var sendAdditionalRows = [];
    if (input_type_element.value == "Select" || input_type_element.value == "Radio" || input_type_element.value == "Checkbox") {
      if (additionalRows.length > 0) {
        additionalRows.map((row, index) => {
          if (row.title && row.deger)
            sendAdditionalRows.push({ title: row.title, deger: row.deger, id: row.id });
        })
      }
      else {
        alert("Lütfen ek bilgileri giriniz");
        return false;
      }
      if (sendAdditionalRows.length == 0) {
        alert("Lütfen ek bilgileri giriniz");
        return false;
      }
    }

    let udata = dispatch(setProformaTheme(input_type_element.value, input_label_element.value, active_proforma, eventname, id, sendAdditionalRows));
    setupdateModalF(true);
    dispatch(getPaymentFlowsThemeAction(pageData.payment_id, pageData.project_id));


    if (udata) {
      if (udata.id) {
        alert('Theme updated successfully!');
      }
    }
    active_theme_type_set(false);
    active_theme_label_set("");


    // Additional logic here
  };


  function filepathChanger(fullPath) {
    // return fullPath
    fullPath = fullPath.replace("https://0.0.0.0:8000/", process.env["REACT_APP_BACKEND_URL"]);
    return fullPath.replace("//media", "/media");
  }



  useEffect(() => {
    console.log("useEffect 1")
    console.log()
    setTitleSubList(pageData.currentSubTitle)
  }, [pageData.currentSubTitle]);


  useEffect(() => {
    if (proformas) {
      if (proformas.msg) {
        setcpp(proformas);
        alert(proformas.msg);
        setUyari(true);
        isFirstRun.current = false;
        setNewProformaModal(false)
        payflowactions(pageData.payment_id)

      }
    }
  }, [proformas, current_proc_proforma, uyari, props]); // Removed props since it's not used inside the effect

  useEffect(() => {
    if (flow_status.msg && isFirstRunPayFLow.current && (new_payment_flow || deleteModal)) {

      setcfs(flow_status);
      alert(flow_status.msg);
      setUyari(true);

      isFirstRunPayFLow.current = false;
      if (new_payment_flow) {
        set_new_payment_flow(!new_payment_flow)
      }
      else if (deleteModal) {
        setDeleteModal(false)
      }
      payflowactions(pageData.payment_id)
    }
    forEach(pageData.payment_theme_flows.proformas_theme, (item, index) => {
      if (item.id == active_proforma) {
        console.log("416")
        active_theme_objects_set(item.objects);
        setActiveProformaId(active_proforma);

      }
    });
    setPageData(props);
    if (active_proforma) {
      proformaObjectDataSet(active_proforma);
    }


  }, [flow_status, current_flow_status, uyari, new_payment_flow, isFirstRunPayFLow, pageData, active_proforma]); // Removed props since it's not used inside the effect
  useEffect(() => {
    if (saved_proforma_status) {
      isFirstRun.current = true;
      setNewProformaModal(false);
      proformaSetpaymentModalData({ title: null, project_id: pageData.project_id, status: false, value: null, id: null, objects: [] });
      setProformaSaveStatus(true);
    }
  }, [saved_proforma_status, saved_proforma]); // Runs when saved_proforma_status changes
  useEffect(() => {
    if (saved_proforma_status_forsw) {
      setProformaSaveStatus(false);
    }
  }, [saved_proforma_status_forsw]);
  useEffect(() => {
  }, [pageData]);
  useEffect(() => {
    if (props_payment_theme_flows.proformas_theme == undefined) {
      setPropsProformas([]);
      setTitleSubList("")
    }
    if (udataGlobal == 0) {
      if (props.payment_theme_flows) {
        // handleModalProformaThemeChange(lastFakeEvent);
        setPropsProformas(props.payment_theme_flows);
        forEach(props.payment_theme_flows.proformas_theme, (item, index) => {
          if (item.id == active_proforma) {
            console.log("453")
            active_theme_objects_set(item.objects);
            setActiveProformaId(active_proforma);

          }
        });
      }
    }
  }, [props_payment_theme_flows, props, active_theme_objects, active_proforma, appendSubmitData, lastFakeEvent, uti, udataGlobal]);

  const handleAdditionalChange = (id, field, value) => {
    setAdditionalRows(
      additionalRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };
  const handle_additional_form = (event, values) => {
    event.preventDefault();
    additionalInputsModalOpenFunc(false);
  };
  const areyousuredelete = (id) => {
    setDeleteModal(true)
    clickedButtonRefCurrent.current = id;
  }
  const payflowactions = (payment_id) => {
    dispatch(getPaymentFlowsThemeAction(payment_id, pageData.project_id));
  }
  const handle_proforma_form = async () => {
    proforma_modal_data.project_id = props.project_id;
    proforma_modal_data.payment_id = props.payment_id;

    try {
      const response = await dispatch(newProformaAction(proforma_modal_data)); // Wait for dispatch response

      await dispatch(getPaymentFlowsThemeAction(props.payment_id, props.project_id)); // Ensure this runs after the first action
      new_proforma_modal_action();
      setProformaSaveStatus(true);
      swopen();
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const deleteProforma = async (id) => {

    try {
      const response = await dispatch(newPayFlow(id, "delete", pageData.project_id, pageData.payment_id));

      await dispatch(getPaymentFlowsThemeAction(props.payment_id, props.project_id)); // Ensure this runs after the first action
    } catch (error) {
      console.error("Error:", error);
    }

  }
  const deleteModalClose = () => {
    setDeleteModal(false)
  }
  const deleteModalOpen = () => {
    setDeleteModal(true)
  }
  const deleteModalAction = () => {
    deleteProforma(clickedButtonRefCurrent.current)
    setDeleteModal(false)
  }
  const updateModalClose = () => {
    setudataGlobal(0);
    setupdateModalF(false)
  }
  const updateModalOpen = () => {
    setupdateModalF(true)
  }
  const updateModalAction = () => {
    setAlertWhenchanged
  }

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="mt-4">
            <div className="d-flex flex-wrap">
              <h5 className="font-size-16 me-3">{titleSubList}</h5>

              <div className="ms-auto">
                {(user_type == 'ADM' || user_type == 'PM') ? (
                  <>
                    <Link to="#" className="fw-medium btn btn-success m-1" onClick={new_theme_modal_action}>
                      + Şablon Ekle
                    </Link>
                    <Link to="#" className="fw-medium btn btn-success m-1" onClick={new_proforma_modal_action}>
                      + Yeni Proforma
                    </Link>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {console.log(props_payment_theme_flows.proformas_theme)}
      {console.log(props.project_id)}
      {props_payment_theme_flows && props_payment_theme_flows.proformas_theme ?
        <div>
          {Object.keys(props_payment_theme_flows.proformas_theme).length > 0 ? (
            <Row>
              <Col xs={12}>

                <Table className="table table-centered table-nowrap mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" style={{ width: "50px" }}>#</th>
                      <th scope="col">Proforma Başlık</th>
                      <th scope="col">Bütçe</th>
                      <th scope="col">Durum</th>
                      <th scope="col">İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props_payment_theme_flows.proformas_theme ? (
                      props_payment_theme_flows.proformas_theme.map((proforma, index) => (
                        <tr key={index} id={`proforma_id_${proforma.id}`}>
                          <td>{index + 1}</td>
                          <td>{proforma.title}</td>
                          <td>{proforma.value}</td>
                          <td>{proforma.status ? "Aktif" : "Pasif"}</td>
                          <td>
                            <div className="d-flex gap-3">
                              {proforma.theme_data.length == 0 ? (
                                <div>
                                  <Link to="#" className="text-danger" onClick={() => areyousuredelete(proforma.id)}>
                                    <i className="mdi mdi-delete font-size-18"></i>
                                  </Link>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">No data found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={12}>

                <div className="text-center mt-4">
                  <h4>Veri Bulunamadı</h4>
                </div>
              </Col>
            </Row>
          )}
        </div>
        : <></>}
      <Modal isOpen={deleteModal} toggle={deleteModalClose}>
        <ModalHeader toggle={deleteModalClose} tag="h4">
          Silme İşlemi
        </ModalHeader>
        <ModalBody>
          <p>Proforma silmek istediğinize emin misiniz?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={deleteModalClose}>
            Kapat
          </Button>
          <Button color="danger" onClick={deleteModalAction}>
            Sil
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={updateModal} toggle={updateModalClose}>
        <ModalBody>
          <h5>Proforma Güncellendi</h5>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={updateModalClose}>
            Kapat
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={new_proforma_modal_show} toggle={new_proforma_modal_action}>
        <ModalHeader toggle={new_proforma_modal_action} tag="h4">
          Proforma Ekle
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={(event, errors, values) => handle_proforma_form()}>
            <Row form>
              <Col xs={12}>
                <div className="mb-3">
                  <AvField
                    name="title"
                    label="Proforma Başlık"
                    type="text"
                    errorMessage="Invalid name"
                    onChange={(e) => proformaSetpaymentModalData({ ...proforma_modal_data, title: e.target.value })}
                    validate={{
                      required: { value: true },
                    }}
                    value={proforma_modal_data.title ? proforma_modal_data.title : ''}
                  />
                </div>
                <div className='mb-3'><label>
                  <input
                    type="radio"
                    class="m-2"
                    name="status"
                    value="true"
                    onChange={(e) => proformaSetpaymentModalData({ ...proforma_modal_data, status: e.target.value === 'true' ? true : false })}
                    checked={proforma_modal_data.status === true}
                  />
                  Aktif
                </label>
                  <label>
                    <input
                      type="radio"
                      class="m-2"
                      value="false"
                      name="status"
                      onChange={(e) => proformaSetpaymentModalData({ ...proforma_modal_data, status: e.target.value === 'true' ? false : true })}
                      checked={proforma_modal_data.status === false}
                    />
                    Pasif
                  </label>
                </div>

                <div className="mb-3">
                  <AvField
                    name="budget"
                    label="Bütçe"
                    type="number"
                    errorMessage="Invalid value"
                    onChange={(e) => proformaSetpaymentModalData({ ...proforma_modal_data, value: e.target.value })}
                    validate={{
                      required: { value: true },
                    }}
                    value={proforma_modal_data.value ? parseFloat(proforma_modal_data.value) : ''}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <button type="submit" className="btn btn-success save-workflow">
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
      <Modal isOpen={new_theme_modal_show} toggle={new_theme_modal_action}>
        <ModalHeader toggle={new_theme_modal_action} tag="h4">
          Yeni Şablon Ekle
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={(event, errors, values) => handle_theme_form()}>

            <Row form>
              <Col xs={12}>

                <div className="mb-3">
                  <AvField
                    name="proforma_id"
                    label="Proforma"
                    type="select"
                    onChange={handleModalProformaThemeChange}
                    errorMessage="Yanlış Proforma"
                    validate={{
                      required: { value: true },
                    }}
                    value={paymentModalData.proforma_id} // Set the value attribute here
                  >
                    <option value="" disabled>Lütfen Seçiniz</option>
                    {props.payment_theme_flows.proformas_theme ? (
                      props.payment_theme_flows.proformas_theme.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.title}
                        </option>

                      ))
                    ) : (
                      <option value="">None</option>
                    )}
                  </AvField>
                  {proforma_select_status ? (
                    <div className="mb-3">
                      <label style={{ display: "block", marginBottom: "0.5rem" }}>Durum</label>

                      <div className="mb-3">
                        <AvField
                          name="is_active"
                          label={activeProformaData.status ? 'Aktif' : 'Pasif'}
                          type="checkbox"
                          onChange={(e) => proformaDurumChange(e, paymentModalData.proforma_id)}
                          checked={activeProformaData.status ? true : false} // Double `!!` ensures boolean
                          value={activeProformaData.status}
                        />
                      </div>
                    </div>
                  ) : (<></>)}

                  {proforma_select_status && active_theme_objects.length > 0 ? (
                    active_theme_objects.map((oitem, index) => (
                      <Row form key={index}>
                        <Col xs={12}>
                          <InputGroup>
                            <div style={{ flex: 1 }}>

                              <label style={{ display: "block", marginBottom: "0.5rem" }}>Etiket</label>

                              <AvField
                                name={`input_label[${oitem.id}]`}
                                type="text"
                                className="form-control"
                                value={oitem.input_label}
                                disabled={activeProformaData.theme_data.length > 0 ? true : false}
                                onChange={(e) => {
                                  // Only allow alphanumeric characters and spaces
                                  const value = e.target.value;
                                  if (value === '' || /^[a-zA-Z0-9\sğüşıöçĞÜŞİÖÇ]+$/.test(value)) {
                                    handleModalProformaThemeChange(e, oitem.id, 1);
                                  } else {
                                    // If input contains special characters, prevent the change
                                    e.target.value = oitem.input_label || '';
                                  }
                                }}
                                onKeyPress={(e) => {
                                  // Prevent typing special characters
                                  if (!/^[a-zA-Z0-9\sğüşıöçĞÜŞİÖÇ]*$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />

                            </div>
                            <div style={{ flex: 1 }}>
                              <label style={{ display: "block", marginBottom: "0.5rem" }}>Tip</label>

                              <AvField
                                name={`input_type[${oitem.id}]`}
                                type="select"
                                // onChange={handleModalProformaThemeChange}
                                onChange={(e) => handleModalProformaThemeChange(e, oitem.id, 1)}
                                className="form-control"
                                disabled={activeProformaData.theme_data.length > 0 ? true : false}
                                value={oitem.input_detail} // Set the value attribute here

                              >
                                <option value="">Lütfen Seçiniz</option>
                                {available_types
                                  ? Object.keys(available_types).map((option, index) => (

                                    <option key={index} value={option} {...(oitem.input_detail == option ? { selected: true } : {})}>
                                      {option}
                                    </option>
                                  ))
                                  : <option value="">None</option>}
                              </AvField>
                            </div>
                            <InputGroupAddon>
                              <label style={{ display: "block", marginBottom: "0.5rem" }}>&nbsp;</label>

                              {oitem.input_detail == "File" || oitem.input_detail == "Text" ? (

                                <Button disabled="true" color="success" onClick={() => toggleAdditionalInputsModal(true, oitem)}>
                                  <i className="mdi mdi-link-plus font-size-12" id="edittooltip" />
                                </Button>
                              ) : (
                                <Button disabled={activeProformaData.theme_data.length > 0 ? true : false} color="success" onClick={() => toggleAdditionalInputsModal(true, oitem)}>
                                  <i className="mdi mdi-link-plus font-size-12" id="edittooltip" />
                                </Button>
                              )
                              }

                              <Button
                                color="danger"
                                onClick={() => updateThemeForProforma(event, oitem.id, oitem.proforma_id, "delete")}
                                disabled={activeProformaData.theme_data.length > 0 ? true : false}
                              >
                                <i className="mdi mdi-delete-forever font-size-12" id="edittooltip" />
                              </Button>
                              <Button
                                id={`editButton_${oitem.id}`}
                                className="editButtonCls"
                                color="primary"
                                disabled={oitem.id == uti ? false : true}
                                onClick={() => updateThemeForProforma(event, oitem.id, oitem.proforma_id, "update")}
                              >
                                <i className="mdi mdi-update font-size-12" id="edittooltip" />
                              </Button>

                            </InputGroupAddon>

                          </InputGroup>
                        </Col>
                      </Row>


                    ))

                  ) : (
                    <></>
                  )}
                  {proforma_select_status && activeProformaData.theme_data.length == 0 ? (

                    <InputGroup>

                      <div style={{ flex: 1 }}>
                        <label style={{ display: "block", marginBottom: "0.5rem" }}>Etiket</label>

                        <AvField
                          name="input_label"
                          type="text"
                          onChange={(e) => {
                            // Only allow alphanumeric characters and spaces
                            const value = e.target.value;
                            if (value === '' || /^[a-zA-Z0-9\sğüşıöçĞÜŞİÖÇ]+$/.test(value)) {
                              handleModalProformaThemeChange(e);
                            } else {
                              // If input contains special characters, prevent the change
                              e.target.value = active_theme_label || '';
                            }
                          }}
                          onKeyPress={(e) => {
                            // Prevent typing special characters
                            if (!/^[a-zA-Z0-9\sğüşıöçĞÜŞİÖÇ]*$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          className="form-control"
                          value={active_theme_label}
                          errorMessage="Sadece harf, rakam ve boşluk kullanabilirsiniz"
                          validate={{
                            required: { value: true },
                            pattern: {
                              value: '^[a-zA-Z0-9 ğüşıöçĞÜŞİÖÇ]+$',
                              errorMessage: 'Sadece harf, rakam ve boşluk kullanabilirsiniz'
                            }
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ display: "block", marginBottom: "0.5rem" }}>Tip</label>

                        <AvField
                          name="input_type"
                          type="select"
                          onChange={handleModalProformaThemeChange}
                          className="form-control"
                          value={active_theme_type} // Set the value attribute here
                          errorMessage="Yanlış Tip"
                          validate={{
                            required: { value: true },
                          }}
                        >
                          <option value="">Lütfen Seçiniz</option>
                          {available_types
                            ? Object.keys(available_types).map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                            : <option value="">None</option>}
                        </AvField>
                      </div>
                      <InputGroupAddon>
                        <label style={{ display: "block", marginBottom: "0.5rem" }}>&nbsp;</label>
                        <Button color="success" id="appendButton" onClick={appendThemeForProforma} disabled={appendButtonDisabledStatus ? "disabled" : ""}>
                          +
                        </Button>
                      </InputGroupAddon>

                    </InputGroup>
                  ) : (<></>)}
                </div>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
      <Modal isOpen={additionalInputsModalOpen} toggle={toggleAdditionalInputsModal}>
        <ModalHeader toggle={toggleAdditionalInputsModal} tag="h4">
          Ek Bilgiler
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={handle_additional_form}>
            {additionalRows.map((row, index) => (
              <Row form key={row.id} className="mb-3 border p-3 rounded">
                <Col xs={12}>
                  <div className="mb-3">
                    <AvField
                      name={`title-${row.id}`}
                      label={`Başlık ${index + 1}`}
                      type="text"
                      errorMessage="Hatalı Başlık"
                      validate={{
                        required: { value: true },
                      }}
                      value={row.title}
                      onChange={(e) => handleAdditionalChange(row.id, 'title', e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <AvField
                      name={`deger-${row.id}`}
                      label={`Değer ${index + 1}`}
                      type="text"
                      errorMessage="Değer Girilmeli"
                      validate={{
                        required: { value: true },
                      }}
                      value={row.deger}
                      onChange={(e) => handleAdditionalChange(row.id, 'deger', e.target.value)}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeAdditionalRow(row.id)}
                    >
                      Satır Sil
                    </button>
                    {index === additionalRows.length - 1 && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addAdditionalRow}
                      >
                        Yeni Satır Ekle
                      </button>
                    )}
                  </div>
                </Col>
              </Row>
            ))}

            <button type="submit" className="btn btn-success mt-3">
              Formu Gönder
            </button>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment >
  )
}

export default APP
